import axios from 'axios';
import Data from '@/common/data';

// 获取当前站配置的ListingStatus
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getListingStatus = params => {
    return axios.get('/api-site/snapshot/listing-status', { params });
};
// 根据listingStatus获取房源数据
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getSnapshotListing = params => {
    if (
        window.sitePageAutoInit === false &&
        Data.pageKey === 'listing-detail-sold' &&
        !Data.isLandingPage
    ) {
        return import(
            /* webpackChunkName: "listing_list_mock"*/ './cms-mock'
        ).then(res => {
            // 对 结果进行一次深拷贝
            return Promise.resolve(JSON.parse(JSON.stringify(res)));
        });
    }
    return axios.get(`/api-site/snapshot/listings`, { params });
};
